import axios from 'axios'

export const initGeo = async (): Promise<void> => {
  if ((window as any).blubolt.geoInitialized) {
    return;
  }
  (window as any).blubolt.geoInitialized = true;

  try {
    const {data} = await axios.get('/browsing_context_suggestions.json')
    const { name, handle } = data.detected_values.country;
    const countryName = name;

    const redirectText = document.querySelector('[data-redirect-text]') as HTMLSpanElement;
    const localizationText = document.querySelector('[data-localization-text]') as HTMLSpanElement;

    const localizationModal = document.querySelector('[data-localization-modal]') as HTMLDivElement;
    const localizationUnderlay = document.querySelector('[data-localization-underlay]') as HTMLButtonElement;
    const localizationClose = document.querySelector('[data-localization-close]') as HTMLAnchorElement;

    const localizationModalActiveClass = 'localization-modal--open';
    const localizationUnderlayActiveClass = 'localization-underlay--open';

    const messageText = redirectText.dataset.redirectText.replace('[[countryName]]', countryName)
    redirectText.innerHTML = messageText;

    const cookieDismissal = window.localStorage.getItem('NFD:localizationDismissed');

    if(handle !== window.Shopify.country && !cookieDismissal){
      localizationText.classList.add('hide');
      localizationModal.classList.add(localizationModalActiveClass);
      localizationUnderlay.classList.add(localizationUnderlayActiveClass);
    }

    const setCookie = (): void => {
      window.localStorage.setItem('NFD:localizationDismissed', 'true');
    }

    localizationUnderlay.addEventListener('click', setCookie);
    localizationClose.addEventListener('click', setCookie);

    const geoSelect = document.querySelector('[data-geo-switcher-select]') as HTMLSelectElement;
    if (geoSelect) {
      geoSelect.addEventListener('change', setCookie);
    }

  } catch (e) {
    console.info(e)
  }
}